import React from 'react';
import {
  getOrderCreationPermissionBadgeVariant,
  getOrderCreationPermissionLabel,
  ORDER_CREATION_PERMISSION_DEFAULT,
} from '../constants/orderCreationPermission';
import './OrderCreationPermissionBadge.css';

const OrderCreationPermissionBadge = ({ value, className = '' }) => {
  const permission = value || ORDER_CREATION_PERMISSION_DEFAULT;
  const variant = getOrderCreationPermissionBadgeVariant(permission);
  const label = getOrderCreationPermissionLabel(permission);

  return (
    <span
      className={`order-permission-badge order-permission-badge--${variant} ${className}`.trim()}
      title={label}
    >
      {label}
    </span>
  );
};

export default OrderCreationPermissionBadge;
